import type { INewsFilters } from '../../../interfaces/NewsFilter.interface';

/**
 * Builds filter array for API request from filter state
 */
export const buildFilterArray = (filters: INewsFilters): string[] => {
  const filterArray: string[] = [];
  Object.entries(filters).forEach(([key, values]) => {
    if (values.length > 0) {
      filterArray.push(...values);
    }
  })
  
  return filterArray;
}

/**
 * Checks if any filters are active
 */
export const hasActiveFilters = (filters: INewsFilters): boolean => {
  return (
    filters.events.length > 0 ||
    filters.index.length > 0 ||
    filters.instrument.length > 0 ||
    filters.marketCap.length > 0 ||
    filters.sector.length > 0
  );
};

